import { Link } from "react-router-dom";
import { AGE_GROUPS } from "~/types/story";

export default function AgeGroupSelector() {
  const ageIcons = ["baby", "child", "book", "brain"];
  const ageEmoji = ["&#x1F476;", "&#x1F9D2;", "&#x1F4DA;", "&#x1F9E0;"];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {AGE_GROUPS.map((group, i) => (
        <Link
          key={group.id}
          to={`/age/${group.id}`}
          className={`group relative overflow-hidden rounded-2xl p-8 bg-gradient-to-br ${group.color} text-white shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 hover:scale-[1.02]`}
        >
          <div className="text-5xl mb-4" dangerouslySetInnerHTML={{ __html: ageEmoji[i] }} />
          <h3 className="text-xl font-bold mb-1">{group.label}</h3>
          <p className="text-sm opacity-90">{group.description}</p>
          <div className="text-xs mt-3 opacity-75">Ages {group.id}</div>

          {/* Decorative circle */}
          <div className="absolute -right-6 -bottom-6 w-24 h-24 rounded-full bg-white/10 group-hover:scale-150 transition-transform duration-500" />
        </Link>
      ))}
    </div>
  );
}
